import { encodeQuery } from 'Helpers/Query';
import {
  householdId, section,
} from 'Consts/Queries';
import { rootUri } from './sharedUris';
import { clientPaths } from './Strings';

const createUri = (path, query = '') => {
  if (typeof path !== 'string') {
    throw new Error(`Invalid parameter "path" which must be a string. Received: ${path}`);
  }

  if (typeof query !== 'string') {
    throw new Error(`Invalid parameter "query" which must be a string. Received: ${query}`);
  }

  return `${rootUri}${path}${query}`;
};

export const dashboardUri = createUri(clientPaths.dashboard);
export const questionnaireUri = createUri(clientPaths.questionnaire);
export const secureFilesUri = hhId => createUri(clientPaths.files, encodeQuery({ [householdId]: hhId }));
export const profileUri = createUri(clientPaths.profile);
export const secureFilesFolderUri = folderName => createUri(clientPaths.files, encodeQuery({ folderName }));

export const dashboardUriWithActionItemsListAnchor = `${dashboardUri}#dashboard-action-items`;
export const disclosureInfoUri = 'https://facetwealth.com/legal-documents';
export const electronicMessageDisclosure = 'https://www.facetwealth.com/electronic-message-disclosure';
export const facetAccountLinkingFAQ = 'https://facetwealth.com/faqs/account-linking-faqs/';
export const familyInfoUri = `${questionnaireUri}/edit/familyInformation`;

const signupBase = `${rootUri}/signup`;
export const signupAgreementBase = `${signupBase}/agreement`;
export const planningAgreementUri = `${signupAgreementBase}/planning`;
export const paymentUri = `${planningAgreementUri}/payment`;
export const signupCompleteUri = `${signupBase}/complete`;

export const clientQuestionnairePath = '/client/questionnaire/edit';
export const goalsObjectivesAndInterestsHref = '/client/questionnaire/edit/goalsObjectivesAndInterests';
export const investmentAssetsHref = '/client/questionnaire/edit/investmentAssets';
export const ssiAndPensionsHref = '/client/questionnaire/edit/ssiAndPensions';
export const liabilitiesHref = '/client/questionnaire/edit/liabilities';
export const estatePlanningHref = '/client/questionnaire/edit/estatePlanning';
export const financialProfileHref = '/client/questionnaire/edit/financialProfile';
export const otherAdvisorsHref = '/client/questionnaire/edit/OtherAdvisors';
export const expenseHref = '/client/questionnaire/edit/Expense';
export const insuranceHref = '/client/questionnaire/edit/insurance';
export const incomeDetailsHref = '/client/questionnaire/edit/incomeDetails';

export const clientSchedulerUri = `${profileUri}?modal=clientSchedulerModal`;

export const clientManagedAccountUriWithQueryParams = (params = {}) => `${clientPaths.managedAccount}${encodeQuery(params)}`;

export const householdInvestmentAssetsUriClient = (id, sectionToExpand) => `${investmentAssetsHref}${encodeQuery({
  [householdId]: id,
  [section]: sectionToExpand,
})}`;

export const clientManagedAccountUri = (id, link, tab = null, isMobile = false) => {
  // query parameters to be included
  const queryParams = {
    [householdId]: id,
    link,
  };
  // optional query parameters
  if (tab !== null) queryParams.tab = tab;
  return clientManagedAccountUriWithQueryParams(queryParams, isMobile);
};

export const uriWithModal = (baseLink, modalName, additionalQueries) => `${baseLink}${encodeQuery({ modal: modalName, ...additionalQueries })}`;

export const dashboardWithModal = (modalName, additionalQueries) => uriWithModal(dashboardUri, modalName, additionalQueries);
